"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.semanticShadowValues = void 0;
const shadow_1 = require("../../typings/shadow");
exports.semanticShadowValues = {
    $shadow100: shadow_1.dropShadowValues.$dropShadow200,
    $shadow200: shadow_1.dropShadowValues.$dropShadow300,
};
